module.exports = __webpack_public_path__ + "img/logo2.726e98c8.png";